import React from 'react';
import LegalLayout from './LegalLayout';
import {CONTACT_EMAIL} from '../siteConfig';

function PrivacyPage() {
  return (
    <LegalLayout kicker="Legal" title="Privacy Policy" updated="October 18, 2026">
      <p>
        This policy explains what information Handle My Tech (&quot;we&quot;, &quot;us&quot;) collects, how we use it, and the choices you have. Handle My Tech is based in Surprise, Arizona, and sets up and runs technology services for local businesses, including messaging, booking, reviews, payments and websites.
      </p>

      <h2>Information we collect</h2>
      <ul>
        <li><strong>Information you give us:</strong> your name, email address, phone number, business name and address, and anything you send us by email, text message, phone or through our app.</li>
        <li><strong>Account information:</strong> your login details and the settings and content you add to your app and website.</li>
        <li><strong>Payment information:</strong> handled by our payment processor. We do not store full card numbers.</li>
        <li><strong>Technical information:</strong> basic details such as browser type, device and pages visited, collected by our hosting providers to keep the site running and secure.</li>
      </ul>

      <h2>How we use your information</h2>
      <ul>
        <li>To set up, run and support your services, app and website.</li>
        <li>To reply to your questions and requests.</li>
        <li>To send account, billing and service messages, including appointment confirmations and reminders.</li>
        <li>To send text messages you have agreed to receive (see below).</li>
        <li>To keep our services secure and to meet legal obligations.</li>
      </ul>

      <h2>Text messages (SMS)</h2>
      <p>
        If you give us your mobile number and agree to receive texts, or you text or call us first, we may text you about your inquiry, appointments, service updates and requests for feedback. Message frequency varies. Message and data rates may apply. Reply STOP at any time to stop receiving texts, or HELP for help.
      </p>
      <p>
        No mobile information will be shared with third parties or affiliates for marketing or promotional purposes. All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.
      </p>

      <h2>When we share information</h2>
      <p>
        We do not sell your personal information. We share it only with service providers that help us run our business, such as hosting, customer messaging, email and payment providers, and only so they can provide those services to us. We may also share information if the law requires it.
      </p>

      <h2>How long we keep it</h2>
      <p>
        We keep your information for as long as your account is active or as needed to provide our services, and afterwards only as long as required for legal, tax or accounting reasons.
      </p>

      <h2>Your choices</h2>
      <ul>
        <li>Reply STOP to any text message to opt out of texts.</li>
        <li>Use the unsubscribe link in any marketing email to opt out of those emails.</li>
        <li>Email us to ask for a copy of your information, or to correct or delete it.</li>
      </ul>

      <h2>Security</h2>
      <p>
        We use reasonable safeguards to protect your information. No method of storing or sending data online is completely secure, but we work to keep your information safe.
      </p>

      <h2>Children</h2>
      <p>Our services are for businesses and are not directed to children under 13.</p>

      <h2>Changes to this policy</h2>
      <p>If we change this policy, we will update the date at the top of this page.</p>

      <h2>Contact us</h2>
      <p>
        Questions about this policy? Email <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
    </LegalLayout>
  );
}

export default PrivacyPage;
